import type { Severity } from "@/shared/ui/severity-dot";

// Цвет быстрой оценки 0–99: от 60 — хорошо, от 40 — средне, ниже — плохо.
export const scoreSeverity = (score: number): Severity =>
  score >= 60 ? "good" : score >= 40 ? "warn" : "bad";
